import { httpClient } from '@services/HttpClient';
import type { ApiResponse, PolicyClaim, CreatePolicyClaimDto, UpdatePolicyClaimDto } from '@repo/types';

export const policyClaimService = {
  async list(policyId: string): Promise<ApiResponse<PolicyClaim[]>> {
    const { data } = await httpClient.get<ApiResponse<PolicyClaim[]>>(
      `/api/v1/policies/${policyId}/claims`,
    );
    return data;
  },

  async getById(policyId: string, claimId: string): Promise<ApiResponse<PolicyClaim>> {
    const { data } = await httpClient.get<ApiResponse<PolicyClaim>>(
      `/api/v1/policies/${policyId}/claims/${claimId}`,
    );
    return data;
  },

  async create(policyId: string, payload: CreatePolicyClaimDto): Promise<ApiResponse<PolicyClaim>> {
    const { data } = await httpClient.post<ApiResponse<PolicyClaim>>(
      `/api/v1/policies/${policyId}/claims`,
      payload,
    );
    return data;
  },

  async update(
    policyId: string,
    claimId: string,
    payload: UpdatePolicyClaimDto,
  ): Promise<ApiResponse<PolicyClaim>> {
    const { data } = await httpClient.put<ApiResponse<PolicyClaim>>(
      `/api/v1/policies/${policyId}/claims/${claimId}`,
      payload,
    );
    return data;
  },

  async delete(policyId: string, claimId: string): Promise<void> {
    await httpClient.delete(`/api/v1/policies/${policyId}/claims/${claimId}`);
  },
};
